import React from "react";
import PropTypes from "prop-types";

import NoDataImage from "shared/react_components/EmptyStates/NoDataImage";
import EmptyStateTemplate from "shared/react_components/EmptyStates/EmptyStateTemplate";

const NoData = ({ height, width, headerFontSize, messageFontSize, message }) => (
  <EmptyStateTemplate
    width={width}
    height={height}
    headerFontSize={headerFontSize}
    messageFontSize={messageFontSize}
    headerMessage="No data found!"
    message={message}
    emptyStateImage={NoDataImage}
  />
);

NoData.propTypes = {
  /**
   * The width of the graphic and the message
   */
  width: PropTypes.string,
  /**
   * The height of the graphic
   */
  height: PropTypes.string,
  /**
   * The font size of the header message
   */
  headerFontSize: PropTypes.string,
  /**
   * The font size of the header message
   */
  messageFontSize: PropTypes.string,
  /**
   * A message that explains why the space is empty or what action is needed to populate the space
   */
  message: PropTypes.string.isRequired
};

NoData.defaultProps = {
  width: "300px",
  height: "204px",
  headerFontSize: "14px",
  messageFontSize: "14px"
};

export default NoData;
